module.exports = __webpack_public_path__ + "img/yj.a42fed71.png";